<template>
  <div id="ShipmentImportFilters">
    <v-expansion-panels class="px-5 py-1" accordion>
      <v-expansion-panel class="elevation-1">
        <v-expansion-panel-header color="#f2f2f2" class="px-4">
          <span>Filtrar por</span>
          <template v-slot:actions>
            <v-icon color="black"> mdi-chevron-down </v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mt-2 pb-1">
            <v-col cols="12" md="4">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formattedDate"
                    label="Data"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" :active-picker.sync="activePicker" @change="saveDate"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="directDelivererIdFilter"
                :items="getSummaryData"
                label="Motorista"
                item-text="name"
                item-value="name"
                @change="saveDeliverer"
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="responsibleSelected"
                :items="users"
                label="Usuário responsável / Importado por"
                item-text="name"
                item-value="name"
                @change="saveResponsible"
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="statusSelected"
                :items="statusShipment"
                label="Status"
                item-text="name"
                item-value="id"
                @change="saveStatus"
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" md="12" class="d-flex justify-end align-center">
              <v-btn
                :disabled="!hasFilters"
                elevation="2"
                color="red"
                class="mx-2"
                :dark="hasFilters"
                @click="cleanFilter()"
              >
                Limpar Filtros
              </v-btn>
              <v-btn
                :loading="loading || loadingGetAll"
                :disabled="!hasFilters"
                :dark="hasFilters"
                elevation="2"
                color="green"
                @click="search()"
              >
                Buscar
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
export default {
  name: 'ShipmentImportFilters',
  props: {
    loadingGetAll: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    loading: false,
    menu: false,
    date: null,
    activePicker: null,
    directDelivererIdFilter: null,
    responsibleSelected: null,
    statusSelected: null,
    statusShipment: [],
    users: []
  }),
  mounted() {
    this.fetchAllStatusShipment();
    this.cleanFilter();
    this.fetchAllUsers();
  },
  computed: {
    ...mapGetters('CouriersStore', ['getSummaryData']),

    hasFilters() {
      if (this.date || this.directDelivererIdFilter || this.responsibleSelected || this.statusSelected) {
        return true;
      }
      return false;
    },
    formattedDate() {
      if (!this.date) return '';
      const [year, month, day] = this.date.split('-');
      return `${day}/${month}/${year}`;
    }
  },
  methods: {
    ...mapActions('ShipmentStore', [
      'fetchShipment',
      'toogleShipment',
      'createShipment',
      'fetchShipmentByID',
      'fetchStatusShipment'
    ]),
    ...mapMutations('ShipmentStore', [
      'setItemPerPage',
      'setPageNumber',
      'setFilterCreatedAt',
      'setFilterDirectDelivererName',
      'setFilterStatusId',
      'setFilterResponsibleUserName'
    ]),
    ...mapActions('UserStore', ['fetchListUsers']),

    search() {
      this.$emit('filterSearch');
    },
    async fetchAllStatusShipment() {
      this.loading = true;

      try {
        const data = await this.fetchStatusShipment();

        const statusToRemove = [
          'Importado com Sucesso',
          'Consulta Finalizada',
          'Consultando TMS',
          'Importado com Pendências',
          'Falha ao Consultar TMS',
          'Consulta sem resultados',
          'Duplicado'
        ];
        this.statusShipment = data.filter((item) => !statusToRemove.includes(item.name));
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    async fetchAllUsers() {
      this.loading = true;

      try {
        const data = await this.fetchListUsers();
        this.users = data;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    saveResponsible(event) {
      this.setFilterResponsibleUserName(event);

      this.$emit('filterSearch');
    },
    saveDeliverer(event) {
      this.setFilterDirectDelivererName(event);

      this.$emit('filterSearch');
    },
    saveDate() {
      this.setFilterCreatedAt(this.date);
    },
    saveStatus() {
      this.setFilterStatusId(this.statusSelected);
    },
    cleanFilter() {
      this.setFilterCreatedAt(null);
      this.setFilterDirectDelivererName(null);
      this.setFilterResponsibleUserName(null);
      this.setFilterStatusId(null);
      this.$emit('filterSearch');
      this.clearFilterFields();
    },
    clearFilterFields() {
      this.date = null;
      this.directDelivererIdFilter = null;
      this.responsibleSelected = null;
      this.statusSelected = null;
    }
  }
};
</script>

<style></style>
